var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.865,
    height: 26.466,
    viewBox: "0 0 25.865 26.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11145",
    "data-name": "Path 11145",
    d: "M27.564,12.827H15.233V17.94h7.1c-.662,3.248-3.429,5.113-7.1,5.113a7.82,7.82,0,1,1,0-15.639,7.65,7.65,0,0,1,4.872,1.744l3.85-3.85a13.225,13.225,0,1,0-8.722,23.158c6.617,0,12.632-4.812,12.632-13.233A10.978,10.978,0,0,0,27.564,12.827Z",
    transform: "translate(-2 -2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1534129544",
    "data-name": 1534129544,
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16356",
    "data-name": "Group 16356",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11144",
    "data-name": "Path 11144",
    d: "M0,26.639V11l10.226,7.82Z",
    transform: "translate(-1.203 -5.586)",
    fill: "#fbbc05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16357",
    "data-name": "Group 16357",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11146",
    "data-name": "Path 11146",
    d: "M0,6.617l10.226,7.82,4.211-3.669L28.872,8.421V0H0Z",
    transform: "translate(-1.203 -1.203)",
    fill: "#ea4335"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16358",
    "data-name": "Group 16358",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11148",
    "data-name": "Path 11148",
    d: "M0,22.256,18.045,8.421l4.752.6L28.872,0V28.872H0Z",
    transform: "translate(-1.203 -1.203)",
    fill: "#34a853"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16359",
    "data-name": "Group 16359",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11150",
    "data-name": "Path 11150",
    d: "M34.053,33.256,15.406,18.82,13,17.015,34.053,11Z",
    transform: "translate(-6.383 -5.586)",
    fill: "#4285f4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ba41eefe103a53540f891ceeb2150ee9.svg";
export { ForwardRef as ReactComponent };